import {isApiTrue}              from "@Common/logic/is-api-true";
import {
    OPTION_SIZE,
    getPickPack,
    getPickPackOptions1,
    getPickPackSizeOptions,
    makeCalOutOfStockTest,
    makeCalOutOfStockTrim,
    makeBaseCal,
    getPickPackOutOfStock,
}                               from "@Common/logic/template-options/template-options-pickpack-data-logic";
import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {Invoke}                 from "@Common/react/invoke";
import {scopedState}            from "@Common/react/scoped-state";
import {Static2}                from "@Common/react/static-2";
import {ErrorHighlighter}       from "@Common/ui-components/light/error-highlighter";
import {
    changeNestedValue,
    getNestedValue,
    setNestedValue
}                               from "@Common/utils/arr-path";
import {chain}                  from "@Common/utils/fs";
import {equalDeep}              from "@Common/utils/objects";

export const PickPackLogic = (
    {
        item,
        templateOptions,
        sequence,
        state,
        next: rootNext,
    }
) => cs(
    consumeContext('apis'),
    ["pickPack", (_, next) => next(getPickPack(templateOptions))],
    ["pickPackOptions", ({pickPack}, next) => next({
        ...getPickPackOptions1(pickPack),
        ...chain(
            getPickPackSizeOptions(pickPack),
            (pickPackSizeOptions) => pickPackSizeOptions && {[OPTION_SIZE]: pickPackSizeOptions}
        ),
    })],
    ["allowBackOrder", (_, next) => next(isApiTrue(templateOptions.options?.find(opt => opt.devKey == "allow_back_order")?.value))],

    // out of stock test is always false (always available) if allowBackOrder
    ["calOutOfStockTest", ({allowBackOrder, pickPack}, next) => next(
        allowBackOrder ? () => false : makeCalOutOfStockTest(pickPack)
    )],
    ["calOutOfStockTrim", ({calOutOfStockTest}, next) => next(makeCalOutOfStockTrim(calOutOfStockTest))],

    // template is out of stock when even an empty cal is out of stock
    ["outOfStockError", ({allowBackOrder, calOutOfStockTest}, next) => next(
        calOutOfStockTest({})
    )],

    ["pickPackSizeChartUrl", (_, next) => next(chain(
        templateOptions.options.filter((o) => o.devKey === "size_chart"),
        (_) => _[0]?.value,
    ))],
    ["optionState", (_, next) => next(scopedState(state, [sequence, "selections", "options"]))],

    ["calSelected", ({optionState},next) => next(
        chain(
            optionState?.value?.find((o) => o?.dev_key === "pick_pack_options"),
            (_) => _ && JSON.parse(_.name),
        )
    )],
    ({calSelected, pickPack, pickPackOptions, calOutOfStockTest},next) => !calSelected && Object.keys(pickPackOptions).length > 0 ? (
        Invoke({
            fn: async () => {
                const updatedState = setNestedValue(state.value, [sequence, "selections", "options"], [
                    {
                        "name": JSON.stringify(makeBaseCal(pickPack)),
                        "dev_key": "pick_pack_options",
                        "error": (!Object.keys(pickPackOptions).every(key => key in makeBaseCal(pickPack)) || calOutOfStockTest(makeBaseCal(pickPack)))
                    },
                ]);
                updatedState && state.onChange(updatedState);
            },
            next,
        })
    ) : (
        next()
    ),
    ["step1", ({}, next) => rootNext({
        cleanItem: (item) => changeNestedValue(item, ["components", sequence, "selections", "options"], (_) => _?.filter((o) =>
            o.dev_key !== "pick_pack_options"
        )),
        next,
    })],


    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],

    ({calSelected,calOutOfStockTest,calOutOfStockTrim,domRef,eh,outOfStockError,pickPackOptions,pickPackSizeChartUrl,step1,apis}) => step1.next(
        ["mailing", "shipping", "pickup"].includes(step1.method) && {
            ui: {
                calSelected,
                domRef,
                eh,
                outOfStockError,
                pickPackOptions,
                pickPackSizeChartUrl,
                calOptionSet  : async (option, value) => {
                    const oldCal = {...calSelected, [option]: value};
                    const newCal = calOutOfStockTest(oldCal) ? calOutOfStockTrim(oldCal, option) : oldCal
                    const updatedState = chain(
                        state,
                        (state) => state.value,
                        (state) => (
                            getNestedValue(state, [sequence, "selections", "options"]) ? (
                                changeNestedValue(state, [sequence, "selections", "options"], (_) => [
                                    ..._?.filter((o) => o?.dev_key != "pick_pack_options"),
                                    {
                                        "name": JSON.stringify(newCal),
                                        "dev_key": "pick_pack_options",
                                        "error": ((!Object.keys(pickPackOptions).every(key => key in newCal) || calOutOfStockTest(newCal)))
                                    },
                                ])
                            ) : (
                                setNestedValue(state, [sequence, "selections", "options"], [
                                    {
                                        "name": JSON.stringify(newCal),
                                        "dev_key": "pick_pack_options",
                                        "error": ((!Object.keys(pickPackOptions).every(key => key in newCal) || calOutOfStockTest(newCal)))
                                    },
                                ])
                            )
                        ),
                    );
                    if(!equalDeep(updatedState, state.value))
                    {
                        state.onChange(updatedState);
                    }
                },
                calOptionTest : (option, value) => !calOutOfStockTest({...calSelected, [option]: value}),
            },
        }
    ),
);

